// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class SiteLongResponse {
    static getAttributeTypeMap() {
        return SiteLongResponse.attributeTypeMap;
    }
}
SiteLongResponse.discriminator = undefined;
SiteLongResponse.additionalProperties = false;
SiteLongResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": "Array<string>"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "number"
    },
];
//# sourceMappingURL=siteLongResponse.js.map